import React from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';

const Navbar = ({ setActiveSection, mobileMenuOpen, setMobileMenuOpen }) => {
  const location = useLocation();

  const getActiveClass = (path) => {
    const currentPath = location.pathname;
    if (path === '/' && currentPath === '/') return 'text-emerald-700 font-semibold';
    if (path !== '/' && currentPath.startsWith(path)) return 'text-emerald-700 font-semibold';
    return 'text-gray-700 hover:text-emerald-600';
  };

  const handleNavClick = (section) => {
    setActiveSection(section);
  };

  return (
    <nav className="bg-gradient-to-r from-emerald-100 to-blue-100 shadow-md fixed w-full top-0 z-50 backdrop-blur-sm border-b border-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Logo className="w-12 h-12" />
                <div className="ml-4">
                  <h3 className="text-xl font-bold bg-gradient-to-r from-emerald-600 to-blue-600 bg-clip-text text-transparent">
                    A.G.O Innovations
                  </h3>
                  <p className="text-emerald-600 text-xs">Team Incredible</p>
                </div>
          </div>
          
          <div className="hidden md:flex space-x-8">
            <Link 
              to="/"
              onClick={() => handleNavClick('home')}
              className={getActiveClass('/')}
            >
              Home
            </Link>
            <Link 
              to="/learn"
              onClick={() => handleNavClick('learn')}
              className={getActiveClass('/learn')}
            >
              Learn & Earn
            </Link>
            <Link 
              to="/blog"
              onClick={() => handleNavClick('blog')}
              className={getActiveClass('/blog')}
            >
              Blog
            </Link>
            <Link 
              to="/about"
              onClick={() => handleNavClick('about')}
              className={getActiveClass('/about')}
            >
              About Us
            </Link>
            <Link 
              to="/contact"
              onClick={() => handleNavClick('contact')}
              className={getActiveClass('/contact')}
            >
              Contact
            </Link>
            <Link 
              to="/pricing-policy"
              onClick={() => handleNavClick('pricing-policy')}
              className={getActiveClass('/pricing-policy')}
            >
              Pricing
            </Link>
          </div>
          
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)} 
            className="md:hidden"
          >
            {mobileMenuOpen ? <X className="text-emerald-600" /> : <Menu className="text-emerald-600" />}
          </button>
        </div>
      </div>
      
      {mobileMenuOpen && (
        <div className="md:hidden bg-gradient-to-r from-emerald-50 to-blue-50 border-t border-emerald-200">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link 
              to="/"
              onClick={() => { handleNavClick('home'); setMobileMenuOpen(false); }}
              className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-emerald-100 rounded-lg"
            >
              Home
            </Link>
            <Link 
              to="/learn"
              onClick={() => { handleNavClick('learn'); setMobileMenuOpen(false); }}
              className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-emerald-100 rounded-lg"
            >
              Learn & Earn
            </Link>
            <Link 
              to="/assignment-writing-service"
              onClick={() => setMobileMenuOpen(false)}
              className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-emerald-100 rounded-lg pl-6 text-sm"
            >
              ✍️ Assignment Help
            </Link>
            <Link 
              to="/student-jobs-earn-money"
              onClick={() => setMobileMenuOpen(false)}
              className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-emerald-100 rounded-lg pl-6 text-sm"
            >
              💼 Student Earning
            </Link>
            <Link 
              to="/blog"
              onClick={() => { handleNavClick('blog'); setMobileMenuOpen(false); }}
              className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-emerald-100 rounded-lg"
            >
              Blog
            </Link>
            <Link 
              to="/about"
              onClick={() => { handleNavClick('about'); setMobileMenuOpen(false); }}
              className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-emerald-100 rounded-lg"
            >
              About Us
            </Link>
            <Link 
              to="/contact"
              onClick={() => { handleNavClick('contact'); setMobileMenuOpen(false); }}
              className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-emerald-100 rounded-lg"
            >
              Contact
            </Link>
            <Link 
              to="/pricing-policy"
              onClick={() => { handleNavClick('pricing-policy'); setMobileMenuOpen(false); }}
              className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-emerald-100 rounded-lg"
            >
              Pricing
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
